import { Urls } from '@2meters/types'
import { functions } from 'api/Firebase/firebase-init'
import { httpsCallable } from 'firebase/functions'

export function sendVisitorChatMessage(request: {
  placeId: string
  appointmentId: string
  text: string
}) {
  const fn = httpsCallable(
    functions,
    `${Urls.visitor.prefix}${Urls.visitor.sendVisitorChatMessage}`
  )
  return fn(request)
}
